import { inherits as _inherits, createClass as _createClass, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import { Button } from './Button/index.js';
import { ModalHeader } from './ModalHeader.js';
import { Wizard } from './Wizard.js';
import { i18n } from '../i18n/translate.js';
import { AlertMessageTypes } from '../constants/index.js';
import { AlertMessage } from './AlertMessage/component.js';
import { FAIcon } from './fa-icon/component.js';
import { formatClassName as _formatClassName } from '../utils/formatClassName.js';

var WizardModal = /*#__PURE__*/function (_React$Component) {
  function WizardModal(props) {
    var _this;

    _classCallCheck(this, WizardModal);

    _this = _callSuper(this, WizardModal, [props]);

    _defineProperty(_this, "buildWizard", function () {
      return /*#__PURE__*/React.createElement(Wizard, {
        wizardStep: _this.state.wizardStep,
        initialStep: _this.props.initialStep,
        onCancel: _this.props.onCancel,
        hasButtons: false,
        hasStepIndicator: false,
        overrideSteps: true
      }, React.Children.map(_this.props.children, function (child) {
        return /*#__PURE__*/React.cloneElement(child, {
          goingToStep: _this.state.goingToStep,
          goingDirection: _this.state.goingDirection,
          stepChangeComplete: _this.stepChangeComplete,
          stepChangeCancel: _this.stepChangeCancel,
          canceling: _this.state.canceling,
          cancelComplete: _this.props.onCancel,
          cancelClose: _this.onCancelClose,
          resetSteps: _this.resetSteps
        });
      }));
    });

    _defineProperty(_this, "buildStepIndicator", function () {
      var numChildren = React.Children.count(_this.props.children);
      return React.Children.map(_this.props.children, function (child, i) {
        if (child.props.title) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: "stepindicator-child"
          }, /*#__PURE__*/React.createElement("div", {
            className: i <= _this.state.wizardStep ? 'circle complete' : 'circle'
          }, /*#__PURE__*/React.createElement("div", null, i + 1)), /*#__PURE__*/React.createElement("div", {
            className: "stepindicatorchild-label"
          }, child.props.title)), numChildren - 1 > i ? /*#__PURE__*/React.createElement("div", {
            className: "separator-bar"
          }, /*#__PURE__*/React.createElement("div", null)) : '');
        }
      });
    });

    _defineProperty(_this, "nextStep", function () {
      _this.setState({
        goingToStep: _this.state.wizardStep + 1,
        goingDirection: 'forward'
      }, function () {
        // ECA-3406 is for focus the first element with has-error class
        var inputWithError = document.querySelector('input:invalid');

        if (inputWithError) {
          inputWithError.focus();
        }
      });
    });

    _defineProperty(_this, "stepChangeCancel", function () {
      _this.setState({
        goingToStep: null,
        goingDirection: null
      });
    });

    _defineProperty(_this, "stepChangeComplete", function () {
      if (_this.state.goingToStep === React.Children.count(_this.props.children)) {
        _this.setState({
          goingToStep: null,
          goingDirection: null
        }, function () {
          return _this.onCancelClose(true);
        });
      } else {
        _this.setState({
          goingToStep: null,
          goingDirection: null,
          wizardStep: _this.state.goingToStep
        });
      }
    });

    _defineProperty(_this, "previousStep", function () {
      if (_this.state.wizardStep > 0) {
        _this.setState({
          goingToStep: _this.state.wizardStep - 1,
          goingDirection: 'backward'
        });
      }
    });

    _defineProperty(_this, "resetSteps", function () {
      var _this$modalBody;

      _this.setState({
        wizardStep: 0,
        goingToStep: 0,
        goingDirection: 'backward'
      });

      if (_this.props.onResetSteps) {
        _this.props.onResetSteps();
      }

      var modalBody = (_this$modalBody = _this.modalBody) === null || _this$modalBody === void 0 ? void 0 : _this$modalBody.current;

      if (modalBody) {
        modalBody.scrollTo(0, 0);
      }
    });

    _defineProperty(_this, "onCancel", function () {
      _this.setState({
        canceling: true,
        lastFocus: document.activeElement
      });
    });

    _defineProperty(_this, "onCancelClose", function (close) {
      _this.setState({
        canceling: false
      }, function () {
        if (close) {
          if (_this.props.onCancel) {
            _this.props.onCancel();
          }
        } else {
          if (_this.state.lastFocus && _this.state.lastFocus.focus) {
            setTimeout(function () {
              return _this.state.lastFocus.focus();
            }, 250);
          }
        }
      });
    });

    _defineProperty(_this, "renderScrollableFooter", function () {
      var branded = _this.props.branded;
      return /*#__PURE__*/React.createElement(Modal.Footer, {
        className: "scrollable sticky-footer",
        "data-action": "modal-footer"
      }, /*#__PURE__*/React.createElement("div", {
        className: "info-text m-b-15"
      }, /*#__PURE__*/React.createElement(FAIcon, {
        icon: "arrow-up-arrow-down",
        additionalClasses: "m-r-10"
      }), i18n.t('Scroll to see all required fields')), /*#__PURE__*/React.createElement(Button, {
        className: "btn-full-size m-0 p-15",
        branded: branded,
        style: "primary",
        onClick: _this.nextStep,
        disabled: _this.props.disableContinueButton || !!_this.state.goingToStep,
        "data-action-button": "complete_wizard"
      }, _this.state.finalButtonLabel), !!_this.props.footerText && _this.props.footerText);
    });

    _defineProperty(_this, "renderExtraFooterButtons", function (isLastStep) {
      var renderExtraButtons = _this.props.renderExtraButtons;

      if (!renderExtraButtons || typeof renderExtraButtons !== 'function') {
        return null;
      }

      return renderExtraButtons(_this.state.wizardStep, _this.state.goingToStep, isLastStep, _this.previousStep, _this.nextStep, _this.onCancel);
    });

    _defineProperty(_this, "renderDefaultFooter", function () {
      var _this$props = _this.props,
          footerButtonAttributes = _this$props.footerButtonAttributes,
          footerText = _this$props.footerText,
          renderExtraButtons = _this$props.renderExtraButtons,
          branded = _this$props.branded;
      var _this$state = _this.state,
          wizardStep = _this$state.wizardStep,
          goingToStep = _this$state.goingToStep;
      var isLastStep = wizardStep === React.Children.count(_this.props.children) - 1;
      return /*#__PURE__*/React.createElement(Modal.Footer, {
        className: "sticky-footer",
        "data-action": "modal-footer"
      }, wizardStep > 0 ? /*#__PURE__*/React.createElement(Button, _extends({}, footerButtonAttributes === null || footerButtonAttributes === void 0 ? void 0 : footerButtonAttributes.previousButton, {
        className: "secondary-light pull-left",
        icon: "angle-left",
        onClick: _this.previousStep,
        style: "secondary"
      }), i18n.t(' Previous')) : null, _this.props.allowCancel ? /*#__PURE__*/React.createElement(Button, _extends({}, footerButtonAttributes === null || footerButtonAttributes === void 0 ? void 0 : footerButtonAttributes.cancelButton, {
        className: "secondary-light",
        isDisabled: !!goingToStep,
        onClick: _this.onCancel,
        style: "secondary"
      }), i18n.t('Cancel')) : null, /*#__PURE__*/React.createElement(Button, _extends({}, footerButtonAttributes === null || footerButtonAttributes === void 0 ? void 0 : footerButtonAttributes.nextButton, {
        branded: branded,
        isDisabled: !!goingToStep,
        icon: goingToStep ? 'spinner' : null,
        onClick: _this.nextStep,
        label: isLastStep ? _this.state.finalButtonLabel : i18n.t('Next'),
        rightIcon: !renderExtraButtons ? 'angle-right' : null,
        style: "primary"
      })), _this.renderExtraFooterButtons(isLastStep), !!footerText && footerText);
    });

    _this.state = {
      wizardStep: _this.props.initialStep || 0,
      finalButtonLabel: _this.props.finalButtonLabel || i18n.t('Done')
    };
    _this.modalBody = /*#__PURE__*/React.createRef();
    return _this;
  }

  _inherits(WizardModal, _React$Component);

  return _createClass(WizardModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.finalButtonLabel !== this.props.finalButtonLabel) {
        this.setState({
          finalButtonLabel: this.props.finalButtonLabel
        });
      }
    }
  }, {
    key: "title",
    get: function get() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          title = _this$props2.title,
          useStepTitle = _this$props2.useStepTitle;
      var wizardStep = this.state.wizardStep;

      if (useStepTitle) {
        var currentStep = React.Children.toArray(children)[wizardStep];

        if (currentStep) {
          return currentStep.props.title;
        }
      }

      if (typeof title === 'function') {
        return title(wizardStep);
      }

      return title;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          allowCancel = _this$props3.allowCancel,
          children = _this$props3.children,
          container = _this$props3.container,
          description = _this$props3.description,
          errorMessage = _this$props3.errorMessage,
          hasScrollableForm = _this$props3.hasScrollableForm,
          hasStepIndicator = _this$props3.hasStepIndicator,
          limitHeight = _this$props3.limitHeight,
          modalSize = _this$props3.modalSize,
          wizardClass = _this$props3.wizardClass,
          titleComponentType = _this$props3.titleComponentType,
          descriptionComponentClass = _this$props3.descriptionComponentClass,
          descriptionComponentType = _this$props3.descriptionComponentType;

      var wizardClasses = _formatClassName(['wizard-modal', modalSize && "modal-size-".concat(modalSize), wizardClass, {
        'scrolling-modal': limitHeight
      }]);

      var headerClasses = _formatClassName([{
        scrollable: hasScrollableForm
      }, {
        'has-step-indicator': hasStepIndicator
      }, {
        'with-description': !!description
      }]);

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
        animation: false,
        "aria-labelledby": "form-modal-header",
        backdrop: allowCancel ? true : 'static',
        container: container,
        size: modalSize,
        className: wizardClasses,
        id: "form-modal",
        onHide: this.onCancel,
        show: true
      }, /*#__PURE__*/React.createElement(ModalHeader, {
        className: headerClasses,
        onCancel: this.onCancel,
        canClickOff: allowCancel && !hasScrollableForm,
        title: this.title,
        titleId: "form-modal-header",
        titleComponentType: titleComponentType,
        description: description,
        descriptionComponentClass: descriptionComponentClass,
        descriptionComponentType: descriptionComponentType
      }), hasStepIndicator && React.Children.count(children) > 1 && /*#__PURE__*/React.createElement("div", {
        className: "step-indicator"
      }, this.buildStepIndicator()), errorMessage && /*#__PURE__*/React.createElement(AlertMessage, {
        message: errorMessage,
        messageType: AlertMessageTypes.danger,
        visible: true
      }), /*#__PURE__*/React.createElement(Modal.Body, {
        ref: this.modalBody
      }, this.buildWizard()), this.props.customFooter ? this.props.customFooter : hasScrollableForm ? this.renderScrollableFooter() : this.renderDefaultFooter()));
    }
  }]);
}(React.Component);

_defineProperty(WizardModal, "propTypes", {
  allowCancel: PropTypes.bool,
  branded: PropTypes.bool,
  children: PropTypes.any,
  container: PropTypes.node,
  description: PropTypes.string,
  descriptionComponentClass: PropTypes.string,
  descriptionComponentType: PropTypes.elementType,
  disableContinueButton: PropTypes.bool,
  errorMessage: PropTypes.string,
  finalButtonLabel: PropTypes.string,
  footerButtonAttributes: PropTypes.shape({
    cancelButton: PropTypes.object,
    nextButton: PropTypes.object,
    previousButton: PropTypes.object
  }),
  footerText: PropTypes.string,
  hasScrollableForm: PropTypes.bool,
  hasStepIndicator: PropTypes.bool,
  initialStep: PropTypes.number,
  limitHeight: PropTypes.bool,
  modalSize: PropTypes.string,
  onCancel: PropTypes.func,
  onResetSteps: PropTypes.func,
  renderExtraButtons: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  titleComponentType: PropTypes.elementType,
  useStepTitle: PropTypes.bool,
  wizardClass: PropTypes.string,
  customFooter: PropTypes.instanceOf(Modal.Footer)
});

_defineProperty(WizardModal, "defaultProps", {
  allowCancel: true,
  disableContinueButton: false,
  hasStepIndicator: true
});

WizardModal.displayName = "WizardModal";
export { WizardModal };